const isGoogleMapsUrl = (url: URL) => {
  const hostname = url.hostname.toLowerCase().replace(/\.$/, "");
  const isShortMapsHost =
    hostname === "maps.app.goo.gl" ||
    (hostname === "goo.gl" && url.pathname.startsWith("/maps"));
  const isGoogleHost =
    /^(?:[a-z0-9-]+\.)*google\.(?:com|[a-z]{2,3}|(?:com|co)\.[a-z]{2})$/.test(
      hostname,
    );

  return isShortMapsHost || (isGoogleHost && url.pathname.includes("/maps"));
};

export const getValidGoogleMapsUrl = (value?: string | null) => {
  if (!value) return undefined;

  try {
    const url = new URL(value);
    const isWebUrl = url.protocol === "https:" || url.protocol === "http:";
    return isWebUrl && isGoogleMapsUrl(url) ? url.toString() : undefined;
  } catch {
    return undefined;
  }
};

export const getGoogleMapsEmbedUrl = (value?: string | null) => {
  const validUrl = getValidGoogleMapsUrl(value);
  if (!validUrl) return undefined;

  const url = new URL(validUrl);
  if (/\/embed\/?$/.test(url.pathname)) return url.toString();
  if (!/\/viewer\/?$/.test(url.pathname)) return undefined;

  url.pathname = url.pathname.replace(/\/viewer\/?$/, "/embed");
  return url.toString();
};

export const getGoogleMapsOpenUrl = (value?: string | null) => {
  const validUrl = getValidGoogleMapsUrl(value);
  if (!validUrl) return undefined;

  const url = new URL(validUrl);
  if (/\/embed\/?$/.test(url.pathname)) {
    url.pathname = url.pathname.replace(/\/embed\/?$/, "/viewer");
  }
  return url.toString();
};
